import { REACT_TEMPLATES } from "@app/constants";

// Single entry: path check then dynamic-import legacy or React (separate chunks).
// Base path from Vite (empty string when not using subpath).
const basePath =
  typeof import.meta.env !== "undefined" && import.meta.env.BASE_URL
    ? import.meta.env.BASE_URL.replace(/\/$/, "")
    : "";

const pathname = window.location.pathname;
const search = window.location.search || "";
const hash = window.location.hash || "";
const searchParams = new URLSearchParams(search);
const documentId = searchParams.get("documentId");
const isEmbedRenderRoute =
  searchParams.get("embed") === "1" && !!searchParams.get("oneTimeToken");

// Redirect legacy /pages/index.html to root
if (
  pathname === basePath + "/pages/index.html" ||
  pathname.endsWith("pages/index.html")
) {
  window.location.replace(basePath + "/" + search + hash);
} else {
  const hasDocumentId = search.indexOf("documentId=") !== -1;
  const isMsalCallback = /[#&](code|state)=/.test(hash);
  const isReactRoute =
    (pathname === "/" ||
      pathname === "" ||
      pathname === basePath ||
      pathname === basePath + "/") &&
    (!hasDocumentId || REACT_TEMPLATES.includes(documentId)) &&
    !isMsalCallback;

  if (isReactRoute) {
    import("./authGuard.js").then(
      ({ removeInitLoadingScreen, requireAuth }) => {
        const mountReactApp = () => {
          const root = document.getElementById("root");
          if (root) {
            root.innerHTML = "";
          }
          removeInitLoadingScreen();
          import("@app/main").then((m) => m.mount());
        };

        // Two auth paths:
        // 1) Human users: require MSAL auth before mounting React.
        // 2) Server render (embed=1 + oneTimeToken): skip interactive login so
        //    Playwright can render the page headlessly for PDF generation.
        //    This path is token-gated on the server and is not a public bypass.
        if (isEmbedRenderRoute) {
          mountReactApp();
        } else {
          requireAuth(mountReactApp);
        }
      }
    );
  } else {
    import("./functions/routing.js").then((m) => m.default());
  }
}
